import React from 'react';
import { Stack } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

export const StepSelectRequestFormSkeleton: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <Stack gap={3}>
      <Stack gap={2}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} height={56} className="rounded" />
        ))}
      </Stack>
    </Stack>
  );
};
